import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

// Get config from runtime window object (loaded from config.js)
const config = (window as any).__APP_CONFIG__ || {};
const authority = config.VITE_AUTHORITY || import.meta.env.VITE_AUTHORITY;
const clientId = config.VITE_CLIENT_ID || import.meta.env.VITE_CLIENT_ID;

export const userManager = new UserManager({
  authority,
  // biome-ignore lint/style/useNamingConvention: Expected
  client_id: clientId,
  // biome-ignore lint/style/useNamingConvention: Expected
  redirect_uri: `${window.location.origin}${window.location.pathname}`,
  // biome-ignore lint/style/useNamingConvention: Expected
  post_logout_redirect_uri: window.location.origin,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  revokeTokenTypes: ['refresh_token'],
  automaticSilentRenew: true,
  monitorSession: true, // this allows cross tab login/logout detection
  loadUserInfo: true,
});

export const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};
